"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_hooks_1 = require("@apollo/react-hooks");
var graphql_tag_1 = __importDefault(require("graphql-tag"));
var React = __importStar(require("react"));
var react_hook_form_1 = require("react-hook-form");
var accountStatuses = ['NOT_FOUND', 'DISABLED', 'INVITED', 'ENABLED', 'DECLINED'];
var GET_ACCOUNT_STATUS = (0, graphql_tag_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query GetAccountStatus($email: String!, $autoSendInvite: Boolean) {\n    getAccountStatus(email: $email, autoSendInvite: $autoSendInvite)\n  }\n"], ["\n  query GetAccountStatus($email: String!, $autoSendInvite: Boolean) {\n    getAccountStatus(email: $email, autoSendInvite: $autoSendInvite)\n  }\n"])));
var useEffect = React.useEffect, useRef = React.useRef, useState = React.useState;
var removeAllChildNodes = function (parent) {
    if (!parent)
        return;
    while (parent.firstChild)
        parent.removeChild(parent.firstChild);
};
var defaultEmailNotFoundMessage = "Sorry, we can't find your email in our system.";
var Login = function () {
    var _a = __read(useState(''), 2), errorMessage = _a[0], setErrorMessage = _a[1];
    var _b = __read(useState(), 2), accountStatus = _b[0], setAccountStatus = _b[1];
    var _c = __read(useState(false), 2), showForgotPasswordForm = _c[0], setShowForgotPasswordForm = _c[1];
    var _d = __read((0, react_hooks_1.useLazyQuery)(GET_ACCOUNT_STATUS, {
        fetchPolicy: 'no-cache',
        onCompleted: function (data) {
            setAccountStatus(data.getAccountStatus);
        },
        onError: function (err) {
            setErrorMessage(err.message);
        },
    }), 2), getAccountStatus = _d[0], getAccountStatusLoading = _d[1].loading;
    var _e = (0, react_hook_form_1.useForm)({}), register = _e.register, handleSubmit = _e.handleSubmit;
    var rawLoginFormEl = useRef(document.getElementById('customer_login'));
    var loginFormEl = useRef(null);
    var rawForgotPasswordFormEl = useRef(document.getElementById('recover_customer_password'));
    var forgotPasswordFormEl = useRef(null);
    var emailInputEl = useRef(document.getElementById('CustomerEmail'));
    var loginErrorsEl = useRef(document.getElementById('loginErrors'));
    var forgotPasswordErrorsEl = useRef(document.getElementById('forgotPasswordErrors'));
    useEffect(function () {
        var _a, _b, _c, _d;
        // when the page loads, check the shopify login form for errors
        // if there are any, set the custom error in this app and clear them from the DOM
        if ((_a = loginErrorsEl.current) === null || _a === void 0 ? void 0 : _a.childElementCount) {
            setErrorMessage(((_b = window.loginApp) === null || _b === void 0 ? void 0 : _b.badPasswordMessage) || 'Invalid Password');
            removeAllChildNodes(loginErrorsEl.current);
        }
        // do the same for the forgot password form
        // the only error would be that the email doesn't exist
        if ((_c = forgotPasswordErrorsEl.current) === null || _c === void 0 ? void 0 : _c.childElementCount) {
            setErrorMessage(((_d = window.loginApp) === null || _d === void 0 ? void 0 : _d.emailNotFoundMessage) || defaultEmailNotFoundMessage);
            removeAllChildNodes(forgotPasswordErrorsEl.current);
        }
    }, []);
    // this helper method hides/shows and moves raw DOM elements
    // we're constrained by shopify's account forms on this
    var showOrHideEls = function (shouldShow, rawEl, el) {
        var _a, _b;
        if (shouldShow) {
            if (!rawEl.current)
                throw new Error("missing rawLoginFormEl.current");
            rawEl.current.classList.remove('hide');
            (_a = el.current) === null || _a === void 0 ? void 0 : _a.appendChild(rawEl.current);
        }
        else {
            (_b = rawEl.current) === null || _b === void 0 ? void 0 : _b.classList.add('hide');
        }
    };
    useEffect(function () {
        showOrHideEls(accountStatus === 'ENABLED', rawLoginFormEl, loginFormEl);
    }, [accountStatus]);
    useEffect(function () {
        showOrHideEls(showForgotPasswordForm, rawForgotPasswordFormEl, forgotPasswordFormEl);
    }, [showForgotPasswordForm]);
    return (React.createElement("div", { className: 'margin-bottom-10' },
        React.createElement("h4", { className: 'h4' }, showForgotPasswordForm ? 'Recover Password' : 'Log In'),
        errorMessage && React.createElement("div", { className: 'text-pastel-red' }, errorMessage),
        React.createElement("div", { className: 'margin-bottom-4' }, (function () {
            var _a, _b;
            if (showForgotPasswordForm)
                return React.createElement("div", { ref: forgotPasswordFormEl });
            switch (accountStatus) {
                case 'DISABLED':
                    return React.createElement("div", null, "Your account was disabled. Please contact Customer Support.");
                case 'INVITED':
                    return React.createElement("div", null, ((_a = window.loginApp) === null || _a === void 0 ? void 0 : _a.inviteSentMessage) || "Check your email for an invite.");
                case 'NOT_FOUND':
                    return React.createElement("div", null, ((_b = window.loginApp) === null || _b === void 0 ? void 0 : _b.emailNotFoundMessage) || defaultEmailNotFoundMessage);
                case 'ENABLED':
                    return React.createElement("div", { ref: loginFormEl });
                default:
                    return (React.createElement("div", null,
                        React.createElement("form", { onSubmit: handleSubmit(function (_a) {
                                var email = _a.email;
                                getAccountStatus({ variables: { email: email, autoSendInvite: true } });
                            }) },
                            React.createElement("div", null,
                                React.createElement("input", { type: 'email', name: 'email', placeholder: 'Email', ref: register({ required: true }), onChange: function (e) {
                                        // keep the raw email input in-sync with the app's email input
                                        if (emailInputEl.current)
                                            emailInputEl.current.value = e.target.value;
                                    } })),
                            React.createElement("button", { type: 'submit', className: 'button display-block width-100 button-checkout', disabled: getAccountStatusLoading }, "SUBMIT"))));
            }
        })()),
        !showForgotPasswordForm && (React.createElement("div", null,
            React.createElement("button", { onClick: function () {
                    setAccountStatus(undefined);
                    setErrorMessage('');
                    setShowForgotPasswordForm(true);
                }, className: 'text-underline' }, "Forgot password?"))),
        (accountStatus || showForgotPasswordForm) && (React.createElement("div", null,
            React.createElement("button", { onClick: function () {
                    setAccountStatus(undefined);
                    setShowForgotPasswordForm(false);
                }, className: 'text-underline' }, "Start over")))));
};
exports.default = Login;
var templateObject_1;
